import React, { useState } from 'react';
import styled from 'styled-components';
import BlogForm from './BlogForm';


const BlogEditWrapper = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem;
`;

const BlogEdit = () => {



  return (
    <BlogEditWrapper>
      <BlogForm />
    </BlogEditWrapper>
  );
};

export default BlogEdit;



